import React from 'react'
import {
    TabletSticky,
    MobileSticky,
    TheWestHeader,
    AppPromoCard,
    Button,
} from '@the-game/components'
import { AddPlayer, Football } from '@the-game/components/icons'
import {
    MainPage,
    StyledHowToPlaySection,
    StyledHowToPlayCard,
    StyledRegistrationFormContainer,
    StyledHeading,
    StyledAdBanner,
    StyledHeaderSection,
    StyledHeroImage,
    StyledSmallHeading,
    StyledCustomHeroWrapper,
    StyledParagraph,
    HeroSubtitleImage,
} from './Home.styled'
import HomeHeader from './HomeHeader'
import { InlineRegistrationForm } from '../registration/inline-registration'
import { PageHelmet } from '../meta/get-meta'
import { useHideNews } from '../utils/PageStyling'
import { AdUnitWrapper, usePageTargeting } from '@the-game/gpt'
import BoxBreakpointHide from '@the-game/components/BoxBreakpointHide'
import {
    StyledPictureSet,
    StyledPromoCardContainer,
} from '@the-game/components/AppPromoCard/AppPromoCard.styled'
import { useHistory, useLocation } from 'react-router-dom'
import { useUser } from '../authentication/UserContext'
import { environment } from '../../environments/environment'
import { useHomeText } from '../data/useHomeText'
import subtitleImage from './assets/hero-subtitle.png'

export function Home() {
    const location = useLocation()
    const { userManager } = useUser()
    const history = useHistory()
    const { textHtml } = useHomeText()

    const prizeImageUrlBase = `${environment.assetBaseUrl}/public-assets/prize-image-`

    const useImageSubtitle = true

    usePageTargeting('home')
    useHideNews()

    /**
        @param isCricket
        Flips the styling between cricket and AFL, including background pictures and layouts
    */
    const isCricket = true

    return (
        <React.Fragment>
            <PageHelmet page="home" />
            <TheWestHeader />
            <MainPage>
                <HomeHeader />
                <StyledHeaderSection>
                    <StyledHeroImage>
                        <StyledCustomHeroWrapper>
                            <StyledHeading
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{
                                    __html:
                                        textHtml?.title ??
                                        `WELCOME TO <br>THE GAME!`,
                                }}
                            />
                            {useImageSubtitle ? (
                                <HeroSubtitleImage>
                                    <img
                                        src={subtitleImage}
                                        alt="It's game on"
                                    ></img>
                                </HeroSubtitleImage>
                            ) : (
                                <>
                                    <StyledSmallHeading
                                        // eslint-disable-next-line react/no-danger
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                textHtml?.subtitle ??
                                                `SIGN UP FOR FREE <br>TO TIP YOUR FAVOURITE <br>SPORT AND A CHANCE <br>TO WIN PRIZES!`,
                                        }}
                                    />
                                    <StyledParagraph>
                                        T&C's Apply
                                    </StyledParagraph>
                                </>
                            )}
                            <BoxBreakpointHide
                                breakpointProp="lg"
                                isReverse={false}
                            ></BoxBreakpointHide>
                        </StyledCustomHeroWrapper>
                    </StyledHeroImage>

                    <StyledRegistrationFormContainer
                        isCricket={isCricket}
                        component="section"
                        direction="column"
                        gap="md"
                        alignItems="stretch"
                    >
                        <InlineRegistrationForm />
                    </StyledRegistrationFormContainer>
                </StyledHeaderSection>

                <StyledPromoCardContainer paddingType="small">
                    <StyledPictureSet>
                        <source
                            srcSet={`${prizeImageUrlBase}mobile.png`}
                            media={`(max-width: 600px )`}
                        />
                        <source
                            srcSet={`${prizeImageUrlBase}tablet.png`}
                            media={`(max-width: 1200px )`}
                        />
                        <img
                            srcSet={`${prizeImageUrlBase}desktop.png`}
                            alt="prizes"
                        />
                    </StyledPictureSet>
                </StyledPromoCardContainer>

                <StyledPromoCardContainer>
                    <AppPromoCard dismissable={false} />
                </StyledPromoCardContainer>

                <StyledAdBanner>
                    <AdUnitWrapper
                        definition={{
                            id: 'home-leaderboard',
                            size: 'leaderboard',
                        }}
                        noticePosition="none"
                        onEvent={() => undefined}
                    />
                </StyledAdBanner>
                <StyledHowToPlaySection>
                    <StyledHowToPlayCard backgroundColor="white">
                        <h2>How to play</h2>
                        <section>
                            {/* <Football
                                aria-hidden
                                title=""
                                rotate={45}
                                themeColor="bayBlue"
                                size="lg"
                            /> */}
                            <Football
                                aria-hidden
                                title=""
                                size="lg"
                                gradientFill={true}
                            />
                            <h3>Tip your favourite teams each week</h3>
                            <p
                                style={{
                                    // color: '#F16C52',
                                    // color: '#D24D0F',
                                    color: '#158936',
                                }}
                            >
                                Available now
                            </p>
                            <p>
                                Not a tipping pro? Don’t worry! <br />
                                We’ve made tipping simple for beginners and
                                experts alike.
                            </p>
                        </section>
                        <section>
                            <AddPlayer
                                aria-hidden
                                title=""
                                themeColor="bayBlue"
                                size="lg"
                            />

                            <h3>Create or join a competition</h3>
                            <p
                                style={{
                                    color: '#158936',
                                }}
                            >
                                Available now
                            </p>
                            <p>
                                Tip against friends, family and coworkers and
                                aim for 1st place. It’s super easy to create and
                                join competitions too.
                            </p>
                        </section>

                        <Button
                            fluid
                            kind="primary"
                            onClick={() => {
                                if (environment.useAuth0) {
                                    userManager.signinRedirect({
                                        data: { url: location.pathname },
                                        prompt: 'select_account',
                                        extraQueryParams: {
                                            ...userManager.settings
                                                .extraQueryParams,
                                            page_type: 'sign-up',
                                        },
                                    })
                                } else {
                                    history.push('/register')
                                }
                            }}
                            data-cy="register-button"
                            size="lg"
                        >
                            Sign up
                        </Button>
                    </StyledHowToPlayCard>
                </StyledHowToPlaySection>

                <MobileSticky>
                    <AdUnitWrapper
                        definition={{
                            id: 'home-mobile-leaderboard-sticky',
                            size: 'mobileLeaderboard',
                        }}
                        noticePosition="none"
                        onEvent={() => undefined}
                    />
                </MobileSticky>
                <TabletSticky>
                    <AdUnitWrapper
                        definition={{
                            id: 'home-tablet-leaderboard-sticky',
                            size: 'tabletLeaderboard',
                        }}
                        noticePosition="none"
                        onEvent={() => undefined}
                    />
                </TabletSticky>
            </MainPage>
        </React.Fragment>
    )
}

export default Home
